/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {message} from 'antd'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'

class Payment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      payment: [],
      printInfo: [],
      Banks: [],
      bankId: 0,
      lengthPayment: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'bankName_desc',
      getSort: '',
      modalDelete: false,
      modalEdit: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'عنوان',
          value: 'title',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'بانک',
          value: 'bank',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نوع',
          value: 'type',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'وضعیت فعال',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }
  getAllPayments = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${BASE_REPORT.BASE_REPORT_PAYMENT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()
          if (!exportStatus) {
            this.setState({
              payment: response.data.object.result,
              lengthPayment: response.data.object.countAll
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
          this.setState({
            payment: [],
            lengthPayment: 0
          })
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    // sessionStorage.setItem('pageNumber', '1');
    // sessionStorage.setItem('dropDownVal', '10');
    // sessionStorage.setItem('params', '');
    this.getAllPayments(false)
    this.getAllBanks()
  }

  getAllBanks = () => {
    http.get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_LIST_BANK}`, {}).then((res) => {
      if (res.data.error === null) {
        this.setState({
          Banks: res.data.object
        })
      } else {
        this.setState({
          Banks: []
        })
      }
    })
  }

  onResultFetched(data) {
    this.setState({
      payment: data
    })
  }

  changeDropDown(data) {
    this.setState({
      payment: data,
      lengthPayment: sessionStorage.getItem('countAll')
    })
  }

  activate = (numRow) => {
    let status = this.state.payment[numRow].enabled
    if (status) {
      let id = this.state.payment[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DISABLE_PAYMENT}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllPayments()
          } else {
            message.error('عملیات تغییر وضعیت نوع پرداخت موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.payment[numRow].id
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ENABLE_PAYMENT}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllPayments()
          } else {
            message.error('عملیات تغییر وضعیت نوع پرداخت موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deletePayment = (numId) => {
    let payId = this.state.payment[numId].id
    let payName = this.state.payment[numId].title
    sessionStorage.setItem('payId', payId)
    sessionStorage.setItem('payName', payName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('payId')
    sessionStorage.removeItem('payName')
  }

  deleteOk = () => {
    let payId = sessionStorage.getItem('payId')
    let data = {
      id: payId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DELETE_PAYMENT}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          this.getAllPayments()

          message.success('بانک با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  editPayment = (numId) => {
    let payId = this.state.payment[numId].id
    let bankId = this.state.payment[numId].bankId
    this.setState({
      bankId
    })
    let bankName = this.state.payment[numId].bankName
    let payName = this.state.payment[numId].title
    let bank = this.state.payment[numId].bank
    let type = this.state.payment[numId].type
    sessionStorage.setItem('payId', payId)
    sessionStorage.setItem('bankId', bankId)
    sessionStorage.setItem('bankName', bankName)
    sessionStorage.setItem('payName', payName)
    sessionStorage.setItem('bank', bank)
    sessionStorage.setItem('type', type)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }
  EditCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.removeItem('payId')
    sessionStorage.removeItem('payName')
    sessionStorage.removeItem('bankId')
    sessionStorage.removeItem('bankName')
    sessionStorage.removeItem('bank')
  }
  EditOk = () => {
    let payId = sessionStorage.getItem('payId')
    let bankId = this.state.bankId
    var name = document.getElementById('name').value
    var bank = document.getElementById('bank').value
    var type = document.getElementById('type').value
    var typeError = false

    var nameError = false
    var bankError = false
    var formError = false
    var bankIdError = false

    if (name == '') {
      formError = true
      nameError = true
      message.error('نام نوع پرداخت وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (bank == '') {
      formError = true
      bankError = true
      message.error('نام بانک را وارد کنید')
    } else {
      if (!bankError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      typeError = true
      message.error('نوع را وارد کنید')
    } else {
      if (!typeError) {
        this.setState({
          error: ''
        })
      }
    }
    if (bankId == 0) {
      formError = true
      bankIdError = true
      message.error('بانک را وارد کنید')
    } else {
      if (!typeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        accountId: payId,
        name: name,
        bank: bank,
        type: type,
        bankId: bankId
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_EDIT_PAYMENT}`, data)
        .then((response) => {
          if (response.data.error == null) {
            this.getAllPayments()

            message.success('ویرایش مشخصات با موفقیت انجام شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  convertState = (x) => {
    if (x == 100) {
      x = 'کارتخوان'
      return x
    } else if (x == 50) {
      x = 'نقدی'
      return x
    } else if (x == 1) {
      x = 'پرداخت از قبل'
      return x
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllPayments(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllPayments(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllPayments(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    var name = $('#filtername').val()
    var bank = $('#filterbank').val()

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (name !== '' && name.length) {
      filter.name = name.trim()
    }
    if (bank !== '' && bank.length) {
      filter.bank = bank.trim()
    }

    return filter
  }

  filter() {
    // sessionStorage.setItem("params", `name=${name}&bank=${bank}`);

    this.getAllPayments(false)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${BASE_REPORT.BASE_REPORT_PAYMENT}`, {params: filter})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          //   console.log(response.data);
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
            excelReport[i]['type'] = this.convertState(excelReport[i]['type'])
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.getAllPayments(true)
  }
  onChangeSelectBank = (e) => {
    let value = parseInt(e.target.value)

    this.setState({
      bankId: value
    })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let excelColumns = [{title: 'عنوان', value: 'title'}, {title: 'بانک', value: 'bank'}]
    let {pageNumber, pageSize, Banks} = this.state
    let payName = sessionStorage.getItem('payName')
    let bank = sessionStorage.getItem('bank')
    let type = sessionStorage.getItem('type')
    let bankName = sessionStorage.getItem('bankName')

    let name = cookie.load('name')
    let columns = ['ردیف', 'عنوان', 'بانک ', 'نوع', 'وضعیت فعال']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست نوع پرداخت"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((pay, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{pay.title}</td>
                  <td>{pay.bank}</td>
                  <td>{this.convertState(pay.type)}</td>
                  <td>{pay.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست نوع پرداخت ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bank'}
                field={'bank'}
                title={'بانک'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'type'}
                field={'type'}
                title={'نوع'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>لیست نوع پرداخت</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addpayment'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="filtername" type="text" />
                </div>

                <div className="formComponent">
                  <label>بانک</label>
                  <input className="form-control" id="filterbank" type="text" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.payment.map((pay, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{pay.title}</td>
                    <td>{pay.bankName}</td>
                    <td>{this.convertState(pay.type)}</td>
                    <td>
                      <button onClick={() => this.activate(index)}>
                        {pay.enabled ? (
                          <img src={require('../../image/on.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/off.svg')} alt="" />
                        )}
                      </button>
                    </td>
                    <td>
                      <button onClick={() => this.editPayment(index)}>
                        <img src={require('../../image/editDriver.svg')} alt="" />
                      </button>
                    </td>
                    <td>
                      <button onClick={() => this.deletePayment(index)}>
                        <img src={require('../../image/trash.svg')} alt="" />
                      </button>
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthPayment}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف بانک</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف بانک {payName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف بانک
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="sm">
            <ModalHeader toggle={this.EditCancel}>ویرایش {payName}</ModalHeader>
            <ModalBody>
              <div className="formComponent">
                <label>نام (الزامی)</label>
                <input type="text" defaultValue={payName} id="name" className="form-control" />
              </div>

              <div className="formComponent">
                <label>نام بانک (الزامی)</label>
                <input type="text" id="bank" defaultValue={bank} className="form-control" />
              </div>
              <div className="formComponent">
                <label>نوع (الزامی)</label>
                <select id="type" className="form-control">
                  <option value="">-------</option>
                  <option value="prepaid" selected={type == '1' ? true : false}>
                    پرداخت از قبل
                  </option>
                  <option value="cash" selected={type == '50' ? true : false}>
                    نقدی
                  </option>
                  <option value="card" selected={type == '100' ? true : false}>
                    کارتخوان
                  </option>
                </select>
              </div>
              <div className="formComponent">
                <label>
                  بانک (الزامی) <span className="requireFiled">*</span>
                </label>
                <select id="بانک" className="form-control" onChange={this.onChangeSelectBank}>
                  {Banks.map((bank, index) => (
                    <option value={bank.id} selected={this.state.bankId === bank.id ? true : false} key={index}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk}>
                ویرایش بانک
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Payment
